import {
  CartCountProvider,
  ColorSchemeProvider,
  DialogProvider,
  LanguageProvider,
  ModalProvider,
  OptimizationUtils,
} from "@/lib/main";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

OptimizationUtils.windowControlsOverlay();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LanguageProvider>
      <CartCountProvider>
        <ColorSchemeProvider>
          <DialogProvider>
            <ModalProvider>
              <App />
            </ModalProvider>
          </DialogProvider>
        </ColorSchemeProvider>
      </CartCountProvider>
    </LanguageProvider>
  </StrictMode>,
);
